import { call, put } from "redux-saga/effects";
import { enrollmentApi } from "@services/api";
import { getTotalEnrollInstructorActions } from "../slices";

function* getTotalEnrollInstructorWorker({ payload }) {
  //   yield delay(300);
  try {
    yield put(getTotalEnrollInstructorActions.pending());
    const response = yield call(
      enrollmentApi.getTotalEnrollInstructor,
      payload
    );
    yield put(getTotalEnrollInstructorActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getTotalEnrollInstructorActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getTotalEnrollInstructorWorker };
